
import { Link } from 'react-router-dom';
import { BookOpen, Code, Server, Settings } from 'lucide-react';
import { useCategories } from '@/hooks/useCategories';

export function Sidebar() {
  const { data: categoriesData = [] } = useCategories();
  
  // Filter to show only the first few categories in the sidebar
  const visibleCategories = categoriesData.slice(0, 3);

  return (
    <div className="h-full bg-background border-r p-4 pt-20">
      <nav className="space-y-1">
        {visibleCategories.map((category: any) => (
          <Link
            key={category.id}
            to={`/categories/${category.id}`}
            className="flex items-center gap-3 px-3 py-2 text-sm font-medium rounded-md hover:bg-muted group transition-colors"
          >
            <span className="text-muted-foreground group-hover:text-primary transition-colors">
              {category.icon === 'server' ? <Server className="h-4 w-4" /> : <Code className="h-4 w-4" />}
            </span>
            <span>{category.name}</span>
          </Link>
        ))}
        
        <Link
          to="/tutorials"
          className="flex items-center gap-3 px-3 py-2 text-sm font-medium rounded-md hover:bg-muted group transition-colors"
        >
          <span className="text-muted-foreground group-hover:text-primary transition-colors">
            <BookOpen className="h-4 w-4" />
          </span>
          <span>All Tutorials</span>
        </Link>
        
        <Link
          to="/settings"
          className="flex items-center gap-3 px-3 py-2 text-sm font-medium rounded-md hover:bg-muted group transition-colors"
        >
          <span className="text-muted-foreground group-hover:text-primary transition-colors">
            <Settings className="h-4 w-4" />
          </span>
          <span>Settings</span>
        </Link>
      </nav>

      <div className="mt-8">
        <h3 className="px-3 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
          Recent Tutorials
        </h3>
        <div className="mt-2 space-y-1">
          <Link
            to="/tutorials/server-admin/chapters/chapter1"
            className="block px-3 py-2 text-sm rounded-md hover:bg-muted"
          >
            Modern Server Administration
          </Link>
          <Link
            to="/tutorials/docker-essentials/chapters/chapter1"
            className="block px-3 py-2 text-sm rounded-md hover:bg-muted"
          >
            Docker Essentials for Developers
          </Link>
          <Link
            to="/tutorials/nextjs-15-fullstack/chapters/chapter1"
            className="block px-3 py-2 text-sm rounded-md hover:bg-muted"
          >
            Next.js 15: Complete Fullstack
          </Link>
        </div>
      </div>
    </div>
  );
}
